import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  ActiveChatWrapper,
  Heading,
  HorizontalDivider,
  OngoingTextWrapper,
  SubHeading
} from '../Style';
import {
  ActiveChatCardProps,
  ActiveChatCardDispatchProps,
  ActiveChatCardOwnProps,
  TICKET_PROPERTIES,
  ActiveChatCardStateProps,
  METADATA_FIELDS
} from '../utils';
import {
  getZendeskToken,
  getTicketListFromZenDesk,
  setZenDeskActiveChat,
  setActiveChatInfo
} from '../../../redux/actions/help-center-action/help-center-actions';
import { IStore } from '../../../store.type';
import { EventNames, FLOW_TYPE, LOG_TYPE } from '../../../utils/events/eventsConstants';
import { logEvent } from '../../../utils/events/logUserEvents';
import { CHEVRON_RIGHT_LIGHT_ICON, DOUBLE_MESSAGE_ICON, UNREAD_INDICATOR_ICON } from '@Images';

const ActiveChatCard = (
  props: ActiveChatCardProps
): React.ReactElement<ActiveChatCardProps> | null => {
  const [showNotificationDot, setShowNotificationDot] = useState<boolean>(false);
  const [activeChatSubject, setActiveChatSubject] = useState<string>('');
  const {
    getZendeskToken,
    getTicketListFromZenDesk,
    setZenDeskActiveChat,
    isZenDeskActiveChat,
    userFirstName,
    isUserAuthenticated,
    setActiveChatInfo,
    remitterId
  } = props;
  //@ts-ignore
  const { zE: zenDesk } = window;

  const handleShowChat = () => {
    const ctData = {
      flowType: FLOW_TYPE.HELP_CENTER,
      isFromActiveChatIndicator: true,
      query: '',
      externalId: remitterId
    };
    if (zenDesk) {
      zenDesk('messenger', 'open');
      zenDesk('messenger:on', 'open', function () {
        setShowNotificationDot(false);
        logEvent(
          EventNames.HELP_CENTER_ACTIVE_CHAT,
          FLOW_TYPE.HELP_CENTER,
          ctData,
          LOG_TYPE.CLEVER_TAP
        );
      });
    }
  };

  const checkTicketList = async () => {
    const responseForChats = await getTicketListFromZenDesk({
      status: TICKET_PROPERTIES.status.open,
      via: TICKET_PROPERTIES.channel.nativeMessaging
    });
    if (responseForChats?.data?.data?.tickets?.length > 0) {
      const ticketInfo = responseForChats.data.data.tickets[0];
      const customFields = ticketInfo.customFields || [];

      let chatSubject = `Conversation with ${userFirstName || 'User'}`;
      if (customFields?.length > 0) {
        const subjectCustomField = customFields.filter(
          (field: any) => field?.id?.toString() === METADATA_FIELDS.chatSubject
        )?.[0];
        chatSubject = subjectCustomField?.value || chatSubject;
      }

      setActiveChatSubject(chatSubject);
      setActiveChatInfo(ticketInfo);
      setZenDeskActiveChat(true);
    } else {
      setZenDeskActiveChat(false);
    }
  };

  const init = async () => {
    if (isUserAuthenticated) {
      const responseForToken = await getZendeskToken();
      if (responseForToken?.success) {
        if (zenDesk) {
          zenDesk('messenger', 'loginUser', function (callback: (token: string) => void) {
            callback(responseForToken?.token);
          });
        }
      }
      await checkTicketList();
    }
  };

  const handleIncomingMessage = () => {
    if (zenDesk) {
      zenDesk('messenger:on', 'unreadMessages', function (count: number) {
        if (count > 0) setShowNotificationDot(true);
      });
      zenDesk('messenger:on', 'close', async function () {
        setShowNotificationDot(false);
        await checkTicketList();
      });
    }
  };

  useEffect(() => {
    init();
    //eslint-disable-next-line
  }, [isUserAuthenticated]);

  useEffect(() => {
    handleIncomingMessage();
    // eslint-disable-next-line
  }, []);

  if (isZenDeskActiveChat) {
    return (
      <ActiveChatWrapper onClick={handleShowChat}>
        <div className="display-flex">
          <img height={24} width={24} src={DOUBLE_MESSAGE_ICON} alt="chat" />
          <HorizontalDivider />
        </div>
        <OngoingTextWrapper>
          <Heading>Active chat</Heading>
          <SubHeading>{activeChatSubject}</SubHeading>
        </OngoingTextWrapper>
        <div className="display-flex display-center">
          {showNotificationDot ? <img src={UNREAD_INDICATOR_ICON} alt="unread-indicator" /> : null}
          <img alt="forward-arrow" src={CHEVRON_RIGHT_LIGHT_ICON} />
        </div>
      </ActiveChatWrapper>
    );
  } else {
    return null;
  }
};

function mapStateToProps(state: IStore) {
  const {
    rootReducer: {
      userStatusReducer: { remitter_individual_first_name: userFirstName, remitter_id: remitterId },
      helpCenterReducer: { isZenDeskActiveChat },
      userSessionReducer: { is_user_authenticated: isUserAuthenticated }
    }
  } = state;
  return { isZenDeskActiveChat, userFirstName, isUserAuthenticated, remitterId };
}
export default connect<
  ActiveChatCardStateProps,
  ActiveChatCardDispatchProps,
  ActiveChatCardOwnProps,
  any
>(mapStateToProps, {
  getZendeskToken,
  getTicketListFromZenDesk,
  setZenDeskActiveChat,
  setActiveChatInfo
})(ActiveChatCard);
